<template>
    <div id="codeLoadEditRulePanel" class="form-wrapper">
        <PanelDropdown v-model="folderMap" :label="$t('folderMap')" :options="folderOptions" placeholder="None"
            :tooltip="tooltips.shared.folderMap" />
        <FolderFileName v-model="localForm.fileName" :max-length="256" :label="$t('folderFileName')" :tooltip="tooltips.shared.folderFileName" />
        <FeatureToggle class="feature-toggle-div" v-model="tabControl" type="codeLoad" label="" :form="localForm"
            :tooltip="tooltips.codeLoad"></FeatureToggle>
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" label="Expert Notes" />
    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import FeatureToggle from './components/featureToggle.vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import ExpertNotes from './components/expertNotes.vue';
import { useStore } from "@/store";
import tooltips from '@/assets/tooltips/en.json'
import FolderFileName from './components/folderFileName.vue';
const store = useStore();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'codeLoad'
    }
})
const folderOptions = computed(() => {
    const original = store.state.general.folderMaps || [];
    return [{ label: "None", value: null }, { label: "Any", value: -1 }, ...original];
});

const emit = defineEmits(['update:form'])
const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});
const tabControl = ref(true)

const folderMap = computed({
    get() {
        return localForm.value.isFolderMapIdAny ? -1 : localForm.value.folderMapId;
    },
    set(val) {
        if (val === -1) {
            localForm.value.isFolderMapIdAny = true;
            localForm.value.folderMapId = -1;
        } else if (val === null) {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = null;
        } else {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = val;
        }
    },
});

</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.boxed-group {
    width: inherit;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    padding: 12px;
    margin-right: 10px;

}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 3px;
}
</style>
